module.exports = __webpack_public_path__ + "static/media/Shane Walsh.4e2e9d0f.jpeg";